import React, {Component} from 'react';
import PropTypes from "prop-types";
import moment from 'moment';
import Api from "../../utils/Api";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import StaticFunctions from "../../utils/StaticFunctions";
import SearchField from "../../utils/SearchField";
import TableContainer from "../../utils/TableContainer";
import Timeformat from "../../utils/Timeformat";
import CompanyLicenceModalContainer from "./CompanyLicenceModalContainer";

class CompanyOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        timezones: PropTypes.array.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            currentCompanies: null,
            filteredCompanies: null,
        };

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestCompanies = this.requestCompanies.bind(this);
        this.requestAddCompanyLicence = this.requestAddCompanyLicence.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.addCompanyLicence = this.addCompanyLicence.bind(this);

    }

    componentDidMount() {

        this.requestCompanies();

    }

    requestCompanies() {

        if (!this.props.baseData.companies || this.props.baseData.companies.currentCompany === null) {
            return;
        }

        const params = {
            action: 'getCompanyOverview',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    currentCompanies: res,
                    filteredCompanies: this.getTableData(res)
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback);

    }

    requestAddCompanyLicence(companyId, dateLicencedFrom, dateLicencedTill, productName) {

        if (this.props.baseData.companies && this.props.baseData.companies.currentCompany !== null && companyId !== null && dateLicencedFrom && dateLicencedTill && productName) {
            const params = {
                action: 'addCompanyLicence',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                companyId: companyId,
                userId: this.props.baseData.userData.id,
                productName: productName,
                dateLicencedFrom: dateLicencedFrom,
                dateLicencedTill: dateLicencedTill
            };

            const callback = function (res) {
                if (res) {
                    if (res.success) {
                        this.requestCompanies();

                        this.props.baseData.closeModal();
                    }

                    alert(this.translate(res.msgKey));
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback);
        }

    }

    onSearch(name, value) {

        const tableData = this.getTableData(this.state.currentCompanies);
        const filteredData = StaticFunctions.findSubstringInObjArray(tableData, value);

        this.setState({
            filteredCompanies: filteredData
        });

    }

    onCancel() {

        this.setState({
            filteredCompanies: this.getTableData(this.state.currentCompanies),
        });

    }

    companyEdit(company) {

        this.props.changeView('edit', company);

    }

    addCompanyLicence(company, productName) {

        if (company && productName) {
            const timeNow = new moment().unix() * 1000;

            let dateLicencedFrom = null;
            let dateLicencedTill = null;

            if (productName === 'demoLicenceOneMonth') {
                if (company.date_licenced === null || company.date_licenced < timeNow) {
                    dateLicencedFrom = timeNow;
                    dateLicencedTill = new moment().add(30, 'days').unix() * 1000;
                } else {
                    dateLicencedFrom = parseInt(company.date_licenced);
                    dateLicencedTill = parseInt(company.date_licenced) + (60 * 60 * 24 * 30 * 1000);
                }
            } else if (productName === 'initialLicenceOneYear' && company.date_licenced === null) {
                dateLicencedFrom = timeNow;
                dateLicencedTill = new moment().add(1, 'year').add(2, 'weeks').unix() * 1000;
            } else if (productName === 'renewalLicenceOneYear' && company.date_licenced !== null) {
                if (company.date_licenced < timeNow) {
                    dateLicencedFrom = timeNow;
                    dateLicencedTill = new moment().add(1, 'year').unix() * 1000;
                } else {
                    dateLicencedFrom = parseInt(company.date_licenced);
                    dateLicencedTill = parseInt(company.date_licenced) + (60 * 60 * 24 * 365 * 1000);
                }
            } else if (productName === 'renewalLicenceFiveYear' && company.date_licenced !== null) {
                if (company.date_licenced < timeNow) {
                    dateLicencedFrom = timeNow;
                    dateLicencedTill = new moment().add(5, 'year').unix() * 1000;
                } else {
                    dateLicencedFrom = parseInt(company.date_licenced);
                    dateLicencedTill = parseInt(company.date_licenced) + (60 * 60 * 24 * 365 * 1000 * 5);
                }
            }

            if (dateLicencedFrom !== null && dateLicencedTill !== null) {
                this.requestAddCompanyLicence(company.id, dateLicencedFrom, dateLicencedTill, productName);
            }
        }

    }

    setLicenceModal(company) {

        if (!company) return null;

        this.props.baseData.modalData({
            content: <CompanyLicenceModalContainer
                baseData={this.props.baseData}
                company={company}
                onSave={this.addCompanyLicence}
            />,
            height: 300,
            width: 450
        });

    }

    changeView(view, company = null) {

        if (this.props.changeView) this.props.changeView(view, company);

    }

    getTableData(rawData) {

        rawData = (rawData) ? rawData : this.state.currentCompanies;

        const timezone = (this.props.baseData.companies && this.props.baseData.companies.currentCompany) ? this.props.baseData.companies.currentCompany.timezone : 'UTC';
        const rows = [];
        const now = new moment().unix() * 1000;

        for (let i = 0; i < rawData.length; i++) {
			const rowTemp		= rawData[i];
			const dateCreated	= (rowTemp.date_created) ? Timeformat.fromUnix(rowTemp.date_created).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
			const dateLicenced	= (rowTemp.date_licenced) ? Timeformat.fromUnix(rowTemp.date_licenced).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
			const dateDeleted	= (rowTemp.date_deleted) ? Timeformat.fromUnix(rowTemp.date_deleted).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
			const lastChange	= (rowTemp.last_update) ? Timeformat.fromUnix(rowTemp.last_update).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
			const parentCompany	= (rowTemp.id_parent) ? this.getCompanyNameById(rowTemp.id_parent) + ' (' + rowTemp.id_parent + ')' : '-';
   const companyStatus	= this.getCompanyStatus(rowTemp, now);
            const timezoneString = (rowTemp.timezone) ? rowTemp.timezone : '-';

            rows.push({
                id: rowTemp.id,
                companyStatus: (companyStatus) ? this.translate(companyStatus) : '-',
                name: rowTemp.name,
                timezone: timezoneString,
                info: rowTemp.info,
                id_parent: rowTemp.id_parent,
                id_root: rowTemp.id_root,
                parent: parentCompany,
                id_main_user: rowTemp.id_main_user,
                mainUser: rowTemp.main_user_email,
                vatNumber: rowTemp.vat_number,
                location_count: rowTemp.location_count,
                machine_count: rowTemp.machine_count,
                user_count: rowTemp.user_count,
                operator_count: rowTemp.operator_count,
                pattern_count: rowTemp.pattern_count,
                date_created: rowTemp.date_created,
                formated_date_created: dateCreated,
                date_licenced: rowTemp.date_licenced,
                formated_date_licenced: dateLicenced,
                date_deleted: rowTemp.date_deleted,
                formated_date_deleted: dateDeleted,
                last_update: rowTemp.last_update,
                formated_last_update: lastChange,
                api_enabled: rowTemp.api_enabled,
                ai_connector_enabled: rowTemp.ai_connector_enabled
            });
        }
console.debug("rows", rows);
        return rows;

    }

    getCompanyNameById(id) {

        const companies = this.state.currentCompanies;

        if (companies) {
            for (let ix in companies) {
                let c = companies[ix];

                if (String(c.id) === String(id)) return c.name;
            }
        }

        return id;

    }

    getCompanyStatus(company, atTheTime = null) {

        if (!company) return 'unknown';

        if (atTheTime === null) atTheTime = new moment().unix() * 1000;

        const timeForNewCustomer = 365 * 60 * 60 * 24 * 1000;   //  Neukunde, wenn die Firma innerhalb der letzten 365 Tage angelegt wurde und noch keine Lizenz hat.

        let companyStatus = 'noLicence';

        if (company.date_deleted !== null && company.date_deleted > 0) {
            companyStatus = 'deleted';
        } else if (company.date_licenced !== null && company.date_licenced > atTheTime) {
            companyStatus = 'active';
        } else if (company.date_licenced !== null && company.date_licenced <= atTheTime) {
            companyStatus = 'expired';
        } else if (company.date_created !== null && atTheTime - company.date_created < timeForNewCustomer) {
            companyStatus = 'newCustomer';
        }

        return companyStatus;

    }

    getCompanyColumns() {

        return [
            {
                key: 'id',
                nameKey: 'id',
                sortType: 'int',
            },
            {
                key: 'companyStatus',
                nameKey: 'state',
                sortType: 'string',
            },
            {
                key: 'name',
                nameKey: 'name',
                sortType: 'string',
            },
            {
                key: 'timezone',
                nameKey: 'timezone',
                sortType: 'string',
            },
            {
                key: 'parent',
                nameKey: 'parentCompany',
                sortType: 'string',
            },
            {
                key: 'mainUser',
                nameKey: 'myzskLoginId',
                sortType: 'string',
            },
            {
                key: 'vatNumber',
                nameKey: 'vatNumber',
                sortType: 'string',
            },
            {
                key: 'locationCount',
                nameKey: 'locations',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'machineCount',
                nameKey: 'machines',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'userCount',
                nameKey: 'user',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'operatorCount',
                nameKey: 'operator',
                classes: 'text-right',
                sortType: 'int',
            },
            /*{
                key: 'patternCount',
                nameKey: 'pattern',
                classes: 'text-right',
                sortType: 'int',
            },*/
            {
                key: 'dateCreated',
                nameKey: 'dateCreated',
                sortType: 'datetime',
            },
            {
                key: 'dateLicenced',
                nameKey: 'dateLicenced',
                sortType: 'datetime',
            },
            {
                key: 'dateDeleted',
                nameKey: 'dateDeleted',
                sortType: 'datetime',
            },
            {
                key: 'lastChange',
                nameKey: 'lastChange',
                sortType: 'datetime',
            },
            {
                key: 'options',
                nameKey: 'options',
            },
        ];

    }

    getCompanyRows() {

        const data = (this.state.filteredCompanies) ? this.state.filteredCompanies : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];

            rows.push({
                id: rowTemp.id,
                companyStatus: rowTemp.companyStatus,
                name: rowTemp.name,
                timezone: rowTemp.timezone,
                id_parent: rowTemp.id_parent,
                parent: rowTemp.parent,
                mainUser: rowTemp.mainUser,
                vatNumber: rowTemp.vatNumber,
                locationCount: rowTemp.location_count,
                machineCount: rowTemp.machine_count,
                userCount: rowTemp.user_count,
                operatorCount: rowTemp.operator_count,
                //patternCount: rowTemp.pattern_count,
                dateCreated: rowTemp.formated_date_created,
                dateLicenced: rowTemp.formated_date_licenced,
                dateDeleted: rowTemp.formated_date_deleted,
                lastChange: rowTemp.formated_last_update,
                options: <div className="tableOptions">
                    <a className="optionEdit" onClick={() => this.companyEdit(rowTemp)} title={this.translate('edit')}>&nbsp;</a>
                    <a className="optionAddLicence" onClick={() => this.setLicenceModal(rowTemp)} title={this.translate('addLicence')}>&nbsp;</a>
                </div>,
            });
        }

        return rows;

    }

    render() {

        if (!this.state.currentCompanies) return <LoadingSplash color={'dark'} />;

        const filteredCompanies = this.state.filteredCompanies || [];
        const dataCount = filteredCompanies.length;
        const countText = (dataCount === 1) ? this.translate('company') : this.translate('companies');
        const companyColumns = this.getCompanyColumns();
        const companyRows = this.getCompanyRows();

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('selectCompany')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchCompanyOverview"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>

                    <div className="clearfix">
                        <div className="fll">
                            <p>{dataCount} {countText} {this.translate('found')}.</p>
                        </div>

                        <div className="flr">
                            <div className="bottomLinks">
                                <a className="prewLink" onClick={(e) => this.changeView('add')}>{this.translate('addNewCompany')}</a>
                            </div>
                        </div>
                    </div>

                    <div className="clearfix">
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={companyColumns}
                            rows={companyRows}
                            fillGaps="-"
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default CompanyOverviewContainer;
